import { render, staticRenderFns } from "./open.vue?vue&type=template&id=5c9f4892"
import script from "./open.vue?vue&type=script&lang=js"
export * from "./open.vue?vue&type=script&lang=js"
import style0 from "./open.vue?vue&type=style&index=0&id=5c9f4892&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports